import { IHotelStaticInfo } from './../../../../core/models/HotelStaticInfo/hotelStaticInfo.interface';
import { IStateHotelAvailability } from '@store/hotel-availability/hotelAvailability.reducer';
import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  AfterViewInit,
} from '@angular/core';
import { AnalyticsService, DeviceService } from '@core/services';
import { dialogConfig } from '@modals/dialog.configure';
import { ModalHotelIntroComponent } from '@modals/hotel-intro/hotel-intro.component';
import { IHotelIntro } from '@core/models/modals';
import { MbDialog, MbStarsRatingModule, MbIconTextModule, MbIconModule, MbReviewsRatingModule } from '@am/moebius';
import { Store } from '@ngrx/store';
import { AppState } from '@store/app.reducer';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { NgIf } from '@angular/common';

@Component({
    selector: 'hotel-intro',
    templateUrl: './hotel-intro.component.html',
    styleUrls: ['./hotel-intro.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        MbStarsRatingModule,
        MbIconTextModule,
        MbIconModule,
        MbReviewsRatingModule,
    ],
})
export class HotelIntroComponent implements OnInit, AfterViewInit {
  @Input()
  isDisney: boolean;
  @Input()
  isLanding: boolean;
  @Input()
  chain: string;
  @Input()
  rating: number;

  public isMobile: boolean;
  public isHomestay: boolean;
  public beds = 0;
  public maxRoomOccupancy = 0;
  public hotelStaticInfo;
  constructor(
    private analyticsService: AnalyticsService,
    private deviceService: DeviceService,
    private dialog: MbDialog,
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
  ) {
    this.isMobile = this.deviceService.isMobile();
  }

  ngOnInit() {
    this.store
      .select('hotelsAvailability')
      .pipe(filter((result) => result.hotelAvailability !== null))
      .pipe(take(1))
      .subscribe((hotel: IStateHotelAvailability) => {
        if (hotel.hotelAvailability !== null) {
          this.beds = hotel.hotelAvailability.beds;
          this.isHomestay = hotel.hotelAvailability.isHomestay;
          this.maxRoomOccupancy = hotel.hotelAvailability.max_room_occupancy;
        }
      });

    this.store
      .select('hotelStaticInfo')
      .pipe(filter((result) => result !== null))
      .pipe(take(1))
      .subscribe((hotelStaticInfo: IHotelStaticInfo) => {
        this.hotelStaticInfo = hotelStaticInfo;
      });
  }
  ngAfterViewInit() {
    this.cdr.detectChanges();
  }
  public trackViewMap() {
    this.analyticsService.trackEvent({
      section: 'Detail',
      action: 'View Map Link',
      label: 'Show',
    });
    this.openModalMap();
  }

  private openModalMap() {
    if (!this.dialog.isAnyDialogOpen) {
      const dialogData: IHotelIntro = {
        name: this.hotelStaticInfo.name,
        address: this.hotelStaticInfo.address,
        city: this.hotelStaticInfo.city,
        hotel_position: this.hotelStaticInfo.hotel_position,
        stars: this.hotelStaticInfo.stars,
      };
      this.dialog.open(ModalHotelIntroComponent, {
        ...dialogConfig,
        size: 'lg',
        closeBtn: true,
        dialogData: dialogData,
      });
    }
  }
}
